import moment from 'moment-timezone';

function normalizer(data, state = null) {
    const output     = Object.assign({}, data);
    output.from_date = output.from_date ? moment(output.from_date).tz('Asia/Tehran').format('YYYY-MM-DD HH:mm:ss') : null;
    output.to_date   = output.to_date ? moment(output.to_date).tz('Asia/Tehran').format('YYYY-MM-DD HH:mm:ss') : null;
    output.messageable_type = 'brand';

    return output;
}

export {
    normalizer,
}


// WEBPACK FOOTER //
// ./src/containers/BulkMessage/pipeline.js